/* ==========================================================================
   HUMO BARRILES · IDIOMA DE TODA LA PÁGINA
   assets/humo-idioma.js

   La página arranca en español. El visitante cambia con el botón EN / ES
   de la entrada y la elección se recuerda en su navegador.

   Cualquier elemento con data-es y data-en se traduce solo.
   Para un atributo en vez del texto: data-i18n-attr="placeholder".
   Las secciones con textos dinámicos escuchan el evento humo:idioma.
   ========================================================================== */
(function () {
  'use strict';

  if (window.HUMO_IDIOMA) return;

  var CLAVE = 'humo-lang';
  var lang = 'es';
  try { if (localStorage.getItem(CLAVE) === 'en') lang = 'en'; } catch (e) {}

  var heroListo = false;

  function aplicar(raiz) {
    var nodos = (raiz || document).querySelectorAll('[data-es][data-en]');
    for (var i = 0; i < nodos.length; i++) {
      var el = nodos[i];
      var v = el.getAttribute('data-' + lang);
      var attr = el.getAttribute('data-i18n-attr');
      if (attr) el.setAttribute(attr, v);
      else el.innerHTML = v;
    }
    document.documentElement.setAttribute('lang', lang);
  }

  function hero() { return document.getElementById('humo-hero'); }

  function sincronizarHero() {
    var h = hero();
    if (!h || h.getAttribute('data-lang') === lang) return;
    var b = h.querySelector('.hb-hero__idioma button[data-lang="' + lang + '"]');
    if (b) b.click();
  }

  function fijar(nuevo, desdeHero) {
    nuevo = nuevo === 'en' ? 'en' : 'es';
    var cambio = nuevo !== lang;
    lang = nuevo;
    try { localStorage.setItem(CLAVE, lang); } catch (e) {}
    aplicar();
    if (!desdeHero) sincronizarHero();
    if (cambio) document.dispatchEvent(new CustomEvent('humo:idioma', { detail: { lang: lang } }));
  }

  window.HUMO_IDIOMA = {
    get: function () { return lang; },
    set: function (l) { fijar(l, false); },
    aplicar: aplicar
  };

  /* el botón EN / ES de la entrada manda sobre toda la página */
  document.addEventListener('click', function (ev) {
    var b = ev.target && ev.target.closest && ev.target.closest('.hb-hero__idioma button[data-lang]');
    if (b && heroListo) fijar(b.getAttribute('data-lang'), true);
  }, true);

  function arrancar() {
    aplicar();

    var h = hero();
    if (!h) { heroListo = true; return; }

    new MutationObserver(function () {
      if (!heroListo) return;
      var l = h.getAttribute('data-lang');
      if (l && l !== lang) fijar(l, true);
    }).observe(h, { attributes: true, attributeFilter: ['data-lang'] });

    /* espera al motor de la entrada y lo pone en el idioma elegido */
    var n = 0;
    var reloj = setInterval(function () {
      n++;
      if (window.HUMO_HERO || n > 150) {
        clearInterval(reloj);
        setTimeout(function () {
          sincronizarHero();
          setTimeout(function () {
            heroListo = true;
            sincronizarHero();
          }, 350);
        }, 250);
      }
    }, 100);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();
})();
